module.exports = __webpack_public_path__ + "static/media/guarantee_seal_3D.54bd8172.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/guarantee_seal_3D.png
// module id = 1026
// module chunks = 0